import styled from '@emotion/styled';

import { TextField, Theme, Box, OutlinedInput } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    uppercase?: string;
}

export const BoxInput = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    text-align: start; 
    flex-direction: column;
    width: 100%;
    height: 5.68rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        height: 4.7rem;
    }

    @media(min-width: ${theme?.breakpoints.values.lg}px) {
        height: 5.68rem;
    }
 `)

export const InputCustom = styled(TextField)(
    ({ theme }: ParamsStyle) => `
        height: 2.8125rem;
 
        input {
            border-radius: 5px;
            padding: 11px 12px;
            background-color: #FFF;
 
            line-height: 1;
            font-weight: 500;
 
            &::placeholder {
                color: ${theme?.palette.primary.main};
            }
        }
 
        fieldset {
            border: 2px solid ${theme?.palette.grey[400]};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            input {
                height: 2.5rem;
                padding: 0px 12px;
            }
        }
    
        @media(min-width: ${theme?.breakpoints.values.lg}px) {
            height: 2.8175rem;
            input {
                height: 2.8175rem;
            }
        }
`);

export const OutlinedInputCustom = styled(OutlinedInput)(
    ({ theme }: ParamsStyle) => `
        height: 2.8125rem;

        input {
            border-radius: 5px;
            background-color: #FFF;
 
            line-height: 1;
            font-weight: 500;
 
            &::placeholder {
                color: ${theme?.palette.primary.main};
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            height: 2.5rem;
            input {
                padding: 0px 12px;
            }
        }
    
        @media(min-width: ${theme?.breakpoints.values.lg}px) {
            height: 2.8175rem;
        }

        button {
            margin: 0;
        }
 
        fieldset {
            border: 2px solid ${theme?.palette.grey[400]};
        }
    `);
